import {
  GET_SUBSCRIPTION_TEXT,
  GET_SUBSCRIPTION_TEXT_SUCCESS,
  GET_SUBSCRIPTION_TEXT_ERROR,
} from "../../constants/actionTypes";

export const subscriptionTextInitialState = {
  isFetching: true,
  text: {
    choose: `Choose a Subscription`,
    try: `Try FREE for 30 Days`,
    noCredit: "(no credit card required).",
    free: `To sign up, use any Subscribe/Get Free Trial link below and we will bill you later for any paid subscription.`,
    subscribe: "Subscribe/Get Free Trial",
    dollars: "All prices shown are in US Dollars",
    thanks: "Thank you! Your subscription has been activated.",
    redirectMsg: `Go to product`,
    alreadySubscribed: "You are already subscribed.",
    errorCreate: "Error creating subscription.",
  },
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_SUBSCRIPTION_TEXT: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case GET_SUBSCRIPTION_TEXT_SUCCESS: {
      return {
        ...state,
        text: payload,
        isFetching: false,
      };
    }
    case GET_SUBSCRIPTION_TEXT_ERROR: {
      return {
        ...state,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
